import React, { useContext, useRef, useState } from 'react';

import PageContext from '../../Context/PageContext';
import { HandleClasses, HandleStyles, Rnd } from 'react-rnd';

import $ from "jquery";
import { isMobile } from 'react-device-detect';
import { relative } from 'path';
import { createCropElementAction } from '../../history/element.history';

const CropImageCard = (props: any) => {
    const rndRef = useRef<Rnd>(null);
    const val = props.val;

    const { zoomValue, setZoomValue, selectedItem, objItems, history, addItem } = useContext(PageContext);

    //Algo : 
    //fullImage contient la position x et y de l'image entière par rapport à la page (0,0) càd le coin haut gauche
    //cropPart contient avec x,y, le delta de position par rapport à fullImage, (0,0) étant le haut gauche de l'image, dans le ref image
    //ainsi, dans ce composant, l'élément state correspond à cropPart (avec un déplacement dans l'objet fullImage (initCrop))
    //cropPart
    const [state, setState] = useState({
        x: val.crop != null ? getIntSize(val.crop.cropPart.x) : 0,
        y: val.crop != null ? getIntSize(val.crop.cropPart.y) : getIntSize(val.height) * 0.2,
        width: val.crop != null ? getIntSize(val.width) : getIntSize(val.width),
        height: val.crop != null ? getIntSize(val.height) : getIntSize(val.height) * 0.6
    });

    //fullImage
    const [initCrop, setInitCrop] = useState({
        x: val.crop != null && val.crop.isCrop != null ? getIntSize(val.crop.fullImage.x) : val.x,
        y: val.crop != null && val.crop.isCrop != null ? getIntSize(val.crop.fullImage.y) : val.y,
        width: val.crop != null ? getIntSize(val.crop.fullImage.width) : getIntSize(val.width),
        height: val.crop != null ? getIntSize(val.crop.fullImage.height) : getIntSize(val.height)
    });

    React.useEffect(() => {

        //on cacher image-element d'origine et etiquette de déplacement pendant l'opération, pour travailler sur une copie de tous ça
        //attention à bien les réactiver quand on  stop le crop (unselect element ou select et new)
        $("#" + val.id).css('visibility', 'hidden');
        $("#clone-container-" + val.id).css('display', 'none');


        var backPosition = { x: val.x, y: val.y, width: val.width, height: val.height, zoomValue, crop: cloneCrop(val.crop) }

        // composant démontage
        return () => {
            //history
            const action = createCropElementAction(
                val,
                { addItem },
                backPosition,
                { x: val.x, y: val.y, width: val.width, height: val.height, zoomValue, crop: cloneCrop(val.crop) }
            );

            history.add(action);
        };

    }, [])

    function cloneCrop(crop: any) {
        if(crop == null) return null;

        return {
            cropPart: { ...crop.cropPart },
            fullImage: { ...crop.fullImage },
            isCrop: crop.isCrop
        };

    }

    function getIntSize(size: any) {
        if (typeof size === 'string' && size.includes("px"))
            return parseInt(size.replace("px", ""))
        else return size
    }

    function onDragElement(e: any, position: any) {
        calcPositionAndSize(position, state.height, state.width, false);
        setState(prev => ({ ...prev, x: position.x, y: position.y }));
    }

    function onDragElementStop(e: any, position: any) {
        calcPositionAndSize(position, state.height, state.width, true);
        setState(prev => ({ ...prev, x: position.x, y: position.y }));
    }

    function onSizeElement(e: any, ref: any, delta: any, position: any, isStop: boolean) {
        calcPositionAndSize(position, ref.offsetHeight, ref.offsetWidth, isStop);
        setState({ width: ref.offsetWidth, height: ref.offsetHeight, x: position.x, y: position.y });
    }

    function calcPositionAndSize(position: any, height: any, width: any, isStop: boolean) {

        //on initialise les valeurs par défaut de l'image à la première modification (resize, move), c'est à ce moment
        //que l'on valide que l'élément est croppé
        if (val.crop == null) {
            val.crop = {
                isCrop: true,
                fullImage: { x: val.x, y: val.y, width: val.width, height: val.height },
                cropPart: { x: 0, y: getIntSize(val.height) * 0.2, width: getIntSize(val.width), height: getIntSize(val.height) }
            };
        }


        if (isStop) {

            //on met à jour val.x et y, car le crop peut modifier la position du coin haut gauche
            val.x = (position.x) + initCrop.x;
            val.y = (position.y) + initCrop.y;

            //Ici, quand on déplace le cropImage dans fullImage, la position et la taille de fullImage ne change pas !
            //Elle ne changera que plus tard, quand on modifiera l'image dans TextElement

            //la nouvelle taille de l'image crop (c'est son rnd qui prendra cette taille)
            val.width = width;
            val.height = height;

            //on sauvegarde les informations du crop par rapport à fullImage
            //x et y sont le delta ! 
            val.crop.cropPart.x = position.x;
            val.crop.cropPart.y = position.y;
            //on stock aussi ces valeurs ici, même si ce sont les mêmes que val.height et width, elles sont utilisées plus tard pour le calul du coefi d'agrandissement
            val.crop.cropPart.width = width;
            val.crop.cropPart.height = height;

            //on met à jour le react rnd de l'image
            val.rnd.current.updatePosition({ x: val.x, y: val.y });
            val.rnd.current.updateSize({ width: width, height: height });

        }

    }

    const rhC: HandleClasses = {
        bottomLeft: "corner-resize-bottomLeft",
        bottomRight: "corner-resize-c",
        topLeft: "corner-resize-c",
        topRight: "corner-resize-c",
    }

    const cssProp: React.CSSProperties = {
        position: 'absolute',
        borderRadius: '50%',
        backgroundColor: '#fff',
        boxShadow: '0 0 4px 1px rgba(57, 76, 96, .15), 0 0 0 1px rgba(43, 59, 74, .3)',
        zIndex: 999
    }

    const cssPropLine: React.CSSProperties = {
        backgroundColor: '#8b3dff',
        zIndex: 999
    }

    const epaisseurBordure = 6;
    const epaisseurBordureTopBottom = epaisseurBordure / 2;
    var sizeCornerResizeSize = isMobile ? 20 / zoomValue : 15 / zoomValue;
    var sizeCornerResizeAbsolute = sizeCornerResizeSize / 2;

    const cornerStyle: HandleStyles = {
        bottom: { ...cssPropLine, height: epaisseurBordure, bottom: -epaisseurBordureTopBottom },
        bottomLeft: { ...cssProp, left: -sizeCornerResizeAbsolute, bottom: -sizeCornerResizeAbsolute, width: sizeCornerResizeSize, height: sizeCornerResizeSize },
        bottomRight: { ...cssProp, right: -sizeCornerResizeAbsolute, bottom: -sizeCornerResizeAbsolute, width: sizeCornerResizeSize, height: sizeCornerResizeSize },
        left: { ...cssPropLine, width: epaisseurBordure, left: -epaisseurBordureTopBottom },
        right: { ...cssPropLine, width: epaisseurBordure, right: -epaisseurBordureTopBottom },
        top: { ...cssPropLine, height: epaisseurBordure, top: -epaisseurBordureTopBottom },
        topLeft: { ...cssProp, left: -sizeCornerResizeAbsolute, top: -sizeCornerResizeAbsolute, width: sizeCornerResizeSize, height: sizeCornerResizeSize },
        topRight: { ...cssProp, right: -sizeCornerResizeAbsolute, top: -sizeCornerResizeAbsolute, width: sizeCornerResizeSize, height: sizeCornerResizeSize },
    }

    return (
        <div>
            <div className="full-size-img-cadre-element" style={{
                display: 'block',
                height: initCrop.height,
                width: initCrop.width,
                zIndex: 99998, position: 'relative',
                transform: "translate(" + initCrop.x + "px," + initCrop.y + "px)"
            }} >
                <img /*src={val.text === 'upload' ? val.src : "http://localhost:3000/studio" + val.src}*/ src={val.text === 'upload' ? val.src : process.env.REACT_APP_PUBLIC_URL + val.src}
                
                    //prod => src={val.src}
                    style={{
                        pointerEvents: "none",
                        height: '100%', width: '100%', position: 'absolute'
                    }} />

                <div
                    className="overlay"
                    style={{
                        background: 'rgb(0 0 0 / 33%)',
                        height: '100%',
                        width: '100%',
                        clipPath: `polygon(
      0 0, 
      0 100%,
      ${state.x / getIntSize(initCrop.width) * 100}% 100%,
      ${state.x / getIntSize(initCrop.width) * 100}% ${state.y / getIntSize(initCrop.height) * 100}%,
      ${(state.x + getIntSize(state.width)) / getIntSize(initCrop.width) * 100}% ${state.y / getIntSize(initCrop.height) * 100}%,
      ${(state.x + getIntSize(state.width)) / getIntSize(initCrop.width) * 100}% ${(state.y + getIntSize(state.height)) / getIntSize(initCrop.height) * 100}%,
      ${state.x / getIntSize(initCrop.width) * 100}% ${(state.y + getIntSize(state.height)) / getIntSize(initCrop.height) * 100}%,
      ${state.x / getIntSize(initCrop.width) * 100}% 100%,
      100% 100%,
      100% 0
    )`
                    }}
                ></div>

                <Rnd
                    id={'crop-image'}
                    ref={rndRef}
                    resizeHandleStyles={cornerStyle}
                    resizeHandleClasses={rhC}
                    size={{ width: state.width, height: state.height }}
                    position={{ x: state.x, y: state.y }}
                    style={{ zIndex: 99999 }}
                    onDrag={(e, d) => { onDragElement(e, d) }}
                    onDragStop={(e, d) => { onDragElementStop(e, d) }}
                    onResize={(e, direction, ref, delta, position) => {
                        onSizeElement(e, ref, delta, position, false);
                    }}
                    onResizeStop={(e, direction, ref, delta, position) => {
                        onSizeElement(e, ref, delta, position, true);
                    }}
                    bounds="parent"
                    scale={zoomValue}
                    lockAspectRatio={false}
                    enableResizing={{ top: true, right: true, bottom: true, left: true, topRight: true, bottomRight: true, bottomLeft: true, topLeft: true }}
                >
                </Rnd>
            </div>

        </div >
    );
};

export default CropImageCard;